import React from 'react';
import {Helmet} from "react-helmet";
import Header from './partials/header/Header';
import Footer from './partials/footer/index';
import { withTranslation } from 'react-i18next';

class Layout extends React.Component {

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title> BSON Technology </title>
                </Helmet>
                <Header />
                    { this.props.children }
                <Footer/>
            </React.Fragment>
        )

    }
}

export default withTranslation('translation')(Layout)